import React from "react";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type State = { hasError: boolean; error?: unknown };

export default class SdkErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown) {
    // keep this so you can see the real error in console
    // eslint-disable-next-line no-console
    console.error("Metabase SDK crashed:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="rt-panel" style={{ padding: 16 }}>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Something went wrong in the report builder.</div>
            <div style={{ opacity: 0.8, fontSize: 14 }}>Try switching back to Table or reload the page.</div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
